import React from 'react';
import PropTypes from 'prop-types';
import URL from 'url-parse';

import {sendShareRequest} from '~/src/utilities/feed/activity.js';
import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './EmailShare.module.scss';
import i18nStrings from './EmailShare.i18n.json';
import {BeagleEvents, GtmEvents, InteractionSources} from '~/src/utilities/constants/tracking';
import ShareMail from '~/src/components/svg/action/ShareMail';
import {withTypeContext} from '~/src/components/context/TypeContext';
import {TeaserTypes, ContentType, SharePlatformTypes} from '~/src/utilities/constants/types';
import {Asset} from '~/src/utilities/constants/asset';
import {trackGtm} from '~/src/utilities/tracking/gtm';

const getTranslation = initPolyglot(i18nStrings);

class EmailShare extends React.Component {
    getHref = () => {
        const url = new URL(this.props.url);
        const body = encodeURIComponent(`${this.props.lead}\n\n${url.href}`);
        return `mailto:?subject=${getTranslation('mailSubject')}: ${this.props.title}&body=${body}`;
    };

    handleClick = () => {
        const beagleEvent =
            this.props.context.type === TeaserTypes.VIDEOS || this.props.context.type === ContentType.VIDEO
                ? BeagleEvents.VIDEO_SHARE
                : BeagleEvents.STORY_SHARE;
        sendShareRequest(this.props.metadataId, beagleEvent, Asset.STORY, SharePlatformTypes.EMAIL);

        trackGtm(GtmEvents.INTERACTION, {
            interactionSource: InteractionSources.SHARE_OVERLAY,
            interactionType: GtmEvents.SHARE_MAIL
        });
    };

    render() {
        return (
            <a className={css.emailShare} onClick={this.handleClick} href={this.getHref()}>
                <span className={css.shareLogo}>
                    <ShareMail title={getTranslation('shareWithMail')} />
                </span>
                <div>{getTranslation('shareWithMail')}</div>
            </a>
        );
    }
}

if (process.env.NODE_ENV === 'development') {
    EmailShare.propTypes = {
        metadataId: PropTypes.string.isRequired,
        lead: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
    };
}

export default withTypeContext(EmailShare);
